import React, { useState } from "react";
import { Button, Card, CardBody, Col, Collapse, Row } from "reactstrap";
import {
  simulateEffectiveDate,
  simulateEffectiveDateByID,
  lockEmployerEmployeesById,
  terminateDueEmployees,
  lockAllEmoployees,
  calculatePastMonthCommissions,
} from "../../../../slices/admin/thunk";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import simulateIcon from "../../../../assets/images/iconsRoles/simulateIcon.svg";

const SimulatePanel = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const handleSimulateEffectiveDate = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to simulate employer effective date as now",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Please wait...",
          html: "Simulating employer effective date...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          const response = await dispatch(simulateEffectiveDate());

          if (response.payload === true) {
            Swal.fire(
              "Success",
              "Employer effective date simulated",
              "success"
            );
          } else {
            Swal.fire(
              "Error!",
              "Error simulating employer effective date ",
              "error"
            );
          }
        } catch (error) {
          console.log(error);
          Swal.fire("Error!", error, "error");
        }
      }
    });
  };

  const handleSimulateEffectiveDateById = async () => {
    Swal.fire({
      title: "Enter Employer ID",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: false,
      confirmButtonText: "Simulate",
      showLoaderOnConfirm: true,
      preConfirm: (employerId) => {
        return dispatch(simulateEffectiveDateByID({ employerId }))
          .unwrap()
          .then((result) => ({ result, employerId }));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
      .then(({ value }) => {
        if (value.result === true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Employer effective date simulated for employer ID ${value.employerId}.`,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Simulation failed for the employer ID.",
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.error("An error occurred:", error);
      });
  };

  const handleLockAllEmployerEmployees = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to lock all employers employees and send invoices?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Please wait...",
          html: "Locking all employers employees...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          const response = await dispatch(lockAllEmoployees());

          if (response.payload === true) {
            Swal.fire(
              "Success",
              "All employers employees locked successfully ",
              "success"
            );
          } else {
            Swal.fire(
              "Error!",
              "Error locking all employers employees",
              "error"
            );
          }
        } catch (error) {
          console.log(error);
          Swal.fire("Error!", error, "error");
        }
      }
    });
  };

  const handleLockEmployerEmployeesById = async () => {
    Swal.fire({
      title: "Enter Employer ID",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: false,
      confirmButtonText: "Lock",
      showLoaderOnConfirm: true,
      preConfirm: (employerId) => {
        return dispatch(lockEmployerEmployeesById({ employerId }))
          .unwrap()
          .then((result) => ({ result, employerId }));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
      .then(({ value }) => {
        console.log(value.result);
        if (value.result === true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Employer with id ${value.employerId} has been locked successfully`,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Locked failed for the employer ID.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer:
          //     "Please try again later or contact support if the issue persists.",
        });
        console.error("An error occurred:", error);
      });
  };

  const handleTerminateDueEmployees = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to terminate due employees?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Please wait...",
          html: "Terminting due employees...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          const response = await dispatch(terminateDueEmployees()).unwrap();

          console.log("response", response);

          if (response === true) {
            Swal.fire("Succes", "Employees terminated successfully", "success");
          } else {
            Swal.fire("Error!", "Error terminating due employees ", "error");
          }
        } catch (error) {
          console.log(error);
          Swal.fire("Error!", error, "error");
        }
      }
    });
  };

  const handleCalculatePastMonthCommissions = async () => {
    Swal.fire({
      title: "Enter User Id",
      html: `
        <input id="swal-input-userId"
        style="width: 85%;"class="swal2-input" placeholder="Enter User ID">
        <div style="margin-top: 20px;">
          <input type="checkbox" id="swal-checkbox-currentMonth">
          <label for="swal-checkbox-currentMonth">Run for current month</label>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      preConfirm: () => {
        const userId = document.getElementById("swal-input-userId").value;
        const currentMonth = document.getElementById(
          "swal-checkbox-currentMonth"
        ).checked;

        if (!userId) {
          Swal.showValidationMessage("User ID is required");
          return null;
        }

        return { userId, currentMonth };
      },
    }).then(async (result) => {
      if (result.isConfirmed && result.value) {
        const { userId, currentMonth } = result.value;

        Swal.fire({
          title: "Please wait...",
          html: "Calculating past month commissions...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          const response = await dispatch(
            calculatePastMonthCommissions({ userId, currentMonth })
          ).unwrap();

          console.log("response", response);

          if (response === true) {
            Swal.fire(
              "Success",
              "Past month commissions calculated successfully",
              "success"
            );
          } else {
            Swal.fire(
              "Error!",
              "Error calculating past month commissions",
              "error"
            );
          }
        } catch (error) {
          console.log(error);
          Swal.fire(
            "Error!",
            error.message || "Error calculating commissions",
            "error"
          );
        }
      }
    });
  };

  const buttonsSimulate = [
    {
      id: "employer_effective_date_as_now",
      title: "Effective Date",
      description: "Simulate employer effective date as now",
      labelButton: "Employer Effective Date as Now",
      function: handleSimulateEffectiveDate,
    },
    {
      id: "employer_effective_date_by_id",
      title: "Effective Date By Id",
      description:
        "Simulate employer effective date as now for an employer by id",
      labelButton: "Employer Effective Date by ID",

      function: handleSimulateEffectiveDateById,
    },
    {
      id: "lock_all_employer_employees_and_send_invoices",
      title: "Lock All Employer Employees ",
      description: "Lock all  employer employees and send invoices ",
      labelButton: "Lock all",
      function: handleLockAllEmployerEmployees,
    },
    {
      id: "lock_employer_employees_by_Id",
      title: "Lock Employer Employees By Id",
      description: "Lock employer employees by id and send invoice",
      labelButton: "Lock by ID",
      function: handleLockEmployerEmployeesById,
    },
    {
      id: "terminate_due_employees",
      title: "Terminate Due Employees",
      description: "Terminate Due Employees",
      labelButton: "Terminate Due Employees",
      function: handleTerminateDueEmployees,
    },
    {
      id: "calculate_past_month_commissions",
      title: "Calculate Past Month Commissions",
      description:
        "Simulate past month commissions calculation job by dashboard user id",
      labelButton: "Calculate Past Month Commissions",
      function: handleCalculatePastMonthCommissions,
    },
  ];

  return (
    <>
      <div className="col-12 d-flex align-items-center">
        <h2
          htmlFor="like-input"
          className="form-label d-flex align-items-center fw-bold"
        >
          <img src={simulateIcon} alt="simulateIcon" className="me-3" />
          Simulate Panel{" "}
          <Button
            color="transparent"
            onClick={toggle}
            aria-controls="simulate-collapse"
            aria-expanded={isOpen}
          >
            <i
              className={`ri-${isOpen ? "arrow-up-s-fill" : "arrow-down-s-fill"
                } text-dark rounded fs-4`}
            ></i>
          </Button>
        </h2>
      </div>
      <Collapse isOpen={isOpen}>
        <Row className="col-12 d-flex align-items-stretch">
          {buttonsSimulate.map((btn, i) => (
            <Col xxl={12} xl={12} lg={12} md={12} key={btn.id}>
              <Card className="border border-1" style={{ minHeight: "155px" }}>
                <CardBody className="d-flex flex-column">
                  <h5>{btn.title}</h5>
                  <p className="text-muted">{btn.description}</p>
                  <div className="mt-auto">
                    <Button
                      onClick={btn.function}
                      className="btn w-100 btn-primary"
                    >
                      {btn.labelButton}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Collapse>
    </>
  );
};

export default SimulatePanel;
